var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiggyBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 14,
    cy: 46,
    r: 14,
    fill: "#94D8ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 31.833l-3.477-.726a14.674 14.674 0 00-4.494-6.618l2.625-5.763a7.84 7.84 0 00-.565-.23 8.513 8.513 0 00-4.894-.25 8.398 8.398 0 00-4.197 2.486 23.228 23.228 0 00-6.954-1.067C21.527 19.665 13 26.495 13 34.924c0 4.482 2.416 8.538 6.267 11.305l-1.539 4.27a1.412 1.412 0 00.382 1.552c.141.128.307.227.488.291l4.476 1.572c.364.13.766.112 1.118-.047.351-.16.624-.45.76-.807l1.286-3.544c3.8.957 7.785.957 11.586 0l1.27 3.45a1.43 1.43 0 00.758.81 1.48 1.48 0 001.119.044l4.476-1.571a1.466 1.466 0 00.825-.745 1.415 1.415 0 00.044-1.1l-1.538-4.27a15.776 15.776 0 005.032-5.763l4.19-1.57v-6.968z",
    stroke: "#25557B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.47 30.431c-3.86-.49-5.7-3.86-4.93-5.43 1-2.05 3.55-1.09 2.61.91-1.14 2.41-6.4 1.44-6.14-1.82",
    stroke: "#25557B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.218 32.49a1.53 1.53 0 100-3.06 1.53 1.53 0 000 3.06z",
    fill: "#25557B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.43 12.379v-4M31.86 11V5M35.297 12.379v-4",
    stroke: "#25557B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.789 23.578a20.625 20.625 0 013.07-.24c1.028.003 2.054.083 3.07.24a4.671 4.671 0 001.66-3.58 4.73 4.73 0 10-7.8 3.58z",
    fill: "#95D8ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.138 24.74a19.63 19.63 0 00-14.56 0M28.789 23.578a20.625 20.625 0 013.07-.24c1.028.003 2.054.083 3.07.24a4.671 4.671 0 001.66-3.58 4.73 4.73 0 10-7.8 3.58v0z",
    stroke: "#25557B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggyBank);
export default __webpack_public_path__ + "static/media/piggy-bank.651f93b12841b8d675537270822bc559.svg";
export { ForwardRef as ReactComponent };